export default __webpack_public_path__ + "static/media/trx.a92f1650.svg";